const ALIGNMENT_CLASSES = {
  "ql-align-center": "center",
  "ql-align-justify": "justify",
  "ql-align-left": "left",
  "ql-align-right": "right",
};

const normalizeLegacyHtml = (content) => {
  if (!content || typeof DOMParser === "undefined") return content || "";

  const document = new DOMParser().parseFromString(content, "text/html");

  document.body.querySelectorAll("[class*='ql-align-']").forEach((element) => {
    const alignmentClass = Object.keys(ALIGNMENT_CLASSES).find((className) =>
      element.classList.contains(className)
    );

    if (alignmentClass && !element.style.textAlign) {
      element.style.textAlign = ALIGNMENT_CLASSES[alignmentClass];
    }
  });

  return document.body.innerHTML;
};

export default normalizeLegacyHtml;
